
import { computed, defineComponent } from 'vue'
import NavLinks from './partials/NavLinks.vue'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'FooterSix',
  components: {
    NavLinks,
  },
  setup() {
    const { currentTheme, currentMode } = useTheme()

    const inputClasses = computed(() => {
      const { input, borders } = currentTheme.value

      return [input.placeholder, borders.text, borders.focusPrimary]
    })

    return {
      currentTheme,
      currentMode,
      inputClasses,
    }
  },
})
